export const globals = Object.freeze({
    TOKEN: "TOKEN"
});

export default globals;